import { render, staticRenderFns } from "./Ruta.vue?vue&type=template&id=ecc647ae&"
import script from "./Ruta.vue?vue&type=script&lang=js&"
export * from "./Ruta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports